<template>
  <v-menu location="left" min-width="150">
    <template #activator="{ props }">
      <app-button type="icon" v-bind="props">
        <app-material-icon name="more_horiz" />
      </app-button>
    </template>
    <v-list class="py-0">
      <template v-for="item in itemMenu" :key="item.action">
        <v-list-item @click="handleMenuAction(item.action)">
          <template #prepend>
            <div v-if="item.icon"
                 class="d-flex align-center mr-2"
            >
              <app-material-icon :name="item.icon" :color="item.iconColor ?? 'icon-primary'" />
            </div>
          </template>
          <div :class="item.class ?? 'text-text-secondary'">
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </div>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
  export default {
    name: 'SubscriptionTeamsTableItemMenu',
    data () {
      return {
        itemMenu: [
          {
            icon: 'edit',
            text: this.$t('subscriptions.views.SubscriptionTeams.updateTeam'),
            action: 'edit',
          },
          {
            icon: 'delete',
            iconColor: 'icon-danger',
            text: this.$t('common.delete'),
            class: 'text-text-danger',
            action: 'delete',
          },
        ],
      }
    },
    methods: {
      handleMenuAction (action) {
        switch (action) {
          case 'edit':
            this.$emit('open-team-edit-pane')
            break
          case 'delete':
            this.$emit('delete-team')
            break
        }
      },
    },
  }
</script>
